import React from 'react'

import { useGetWidget } from './_configs'
import WidgetWrapper from './WidgetWrapper'

const Widget = props => {
  const config = useGetWidget(props.widget.data?.type)
  const Widget = config?.Presentation

  if (Widget) return <Widget {...props} />
  return <WidgetWrapper bgColor={props.widget.data?.color} {...props} />
}

export default Widget
